<template>
<div class="chapter">
<div class="inner_page">
<div class="Parts-5">
<p class="Title-page-title">Mary &amp; Me</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 00.1_MaryMe.vue?4219d142